import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Notification from '@zg-rentals/multibrand-ui/lib/Notification';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Spinner from '@zg-rentals/multibrand-ui/lib/Spinner';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

// Constants
import LoadingConstants from 'app/shared/constants/LoadingConstants';

import { Link as v4Link } from 'react-router-dom';

// Actions
import BillingActions from 'app/shared/actions/BillingActions';

// Utils
import numberUtils from 'app/shared/utils/numberUtils';

// Stylesheets
import './style.scss';

const propTypes = {
    data: PropTypes.array,
    selected: PropTypes.object,
};

const defaultProps = {
    data: [],
    selected: new Set(),
};

const notificationTypes = {
    [LoadingConstants.LOADING]: 'info',
    [LoadingConstants.SUCCESS]: 'success',
    [LoadingConstants.ERROR]: 'error',
};

const BillingTopBanner = ({
    dispatch,
    data,
    selected,
    downloadState,
    downloadErrorMessage,
}) => {
    const handleNotificationCloseClick = () => {
        dispatch(BillingActions.resetDownloadState());
    };
    const { size } = selected;
    React.useEffect(() => {
        if (size === 0) {
            handleNotificationCloseClick();
        }
    }, [selected]);
    if (data.length === 0) return null;
    const handleDownloadClick = () => {
        const invoiceNumbers = [];
        for (const i of selected) {
            invoiceNumbers.push(data[i].invoiceNumber);
        }
        dispatch(BillingActions.downloadInvoices(invoiceNumbers));
    };
    const getNotificationContent = (downloadState, downloadErrorMessage) => {
        switch (downloadState) {
            case LoadingConstants.LOADING:
                return (
                    <div className="SpinnerDiv">
                        Downloading invoice files...
                        <Spinner />
                    </div>
                );
            case LoadingConstants.SUCCESS:
                return 'Download successful!';
            case LoadingConstants.ERROR:
                return downloadErrorMessage;
            default:
                return '';
        }
    };
    if (size === 0) {
        return (
            <Row className="BillingTopBanner">
                <Col xs={12}>
                    <Text type="h4">Select invoices to download</Text>
                </Col>
            </Row>
        );
    }
    let invoiceAmount = 0;
    let invoiceBalance = 0;
    for (const i of selected) {
        invoiceAmount += data[i].amount;
        invoiceBalance += data[i].balance;
    }
    return (
        <Row className="BillingTopBanner">
            <Col xs={12}>
                {downloadState !== LoadingConstants.INITIAL && (
                    <Notification type={notificationTypes[downloadState]} onClose={handleNotificationCloseClick}>
                        { getNotificationContent(downloadState, downloadErrorMessage) }
                    </Notification>
                )}
                <div className="BillingTopBanner-invoice-count">
                    <Row noPadding={true}>
                        <Text type="h4">
                            {`${size} Invoice${size > 1 ? 's' : ''}`}
                        </Text>
                        <Link
                            onClick={handleDownloadClick}
                            reactRouterLink={v4Link}
                            className="Utils-primary BillingTopBanner-download"
                        >
                            Download PDF
                        </Link>
                    </Row>
                    {invoiceBalance > 0 && (
                        <Row noPadding={true}>
                            <Col xs={12} sm={4}>
                                <div className="BillingTopBanner-amount-wrapper">
                                    <span className="BillingTopBanner-amount-label">
                                        INVOICE AMOUNT
                                    </span>
                                    {numberUtils.asCurrency(invoiceAmount, '$0,0.00')}
                                </div>
                                <div className="BillingTopBanner-amount-wrapper">
                                    <span className="BillingTopBanner-amount-label">
                                        INVOICE BALANCE
                                    </span>
                                    {numberUtils.asCurrency(invoiceBalance, '$0,0.00')}
                                </div>
                            </Col>
                        </Row>
                    )}
                </div>
            </Col>
        </Row>
    );
};

const mapStateToProps = state => ({
    downloadState: state.billing.download.downloadState,
    downloadErrorMessage: state.billing.download.downloadErrorMessage,
});

BillingTopBanner.propTypes = propTypes;
BillingTopBanner.defaultProps = defaultProps;

export default connect(mapStateToProps)(BillingTopBanner);
